/* UrbanGentle header, drawer and small UI helpers (no dependencies) */
(function(){
  'use strict';
  var d=document, body=d.body;

  /* sticky header shadow */
  var header=d.querySelector('[data-ug-header]');
  if(header){
    var onScroll=function(){header.classList.toggle('is-scrolled',window.scrollY>4)};
    onScroll(); window.addEventListener('scroll',onScroll,{passive:true});
  }

  /* desktop dropdowns: click / keyboard toggle, hover handled by CSS */
  var items=d.querySelectorAll('[data-ug-dropdown]');
  function closeAll(except){items.forEach(function(it){if(it!==except){it.classList.remove('is-open');var b=it.querySelector('[aria-expanded]');if(b)b.setAttribute('aria-expanded','false')}})}
  items.forEach(function(it){
    var btn=it.querySelector('button');
    if(!btn)return;
    btn.addEventListener('click',function(e){
      e.preventDefault();
      var open=!it.classList.contains('is-open');
      closeAll(it);
      it.classList.toggle('is-open',open);
      btn.setAttribute('aria-expanded',open?'true':'false');
    });
    it.addEventListener('keydown',function(e){if(e.key==='Escape'){it.classList.remove('is-open');btn.setAttribute('aria-expanded','false');btn.focus()}});
  });
  d.addEventListener('click',function(e){if(!e.target.closest('[data-ug-dropdown]'))closeAll(null)});

  /* search panel */
  var sPanel=d.querySelector('[data-ug-search]');
  d.querySelectorAll('[data-ug-search-toggle]').forEach(function(t){
    t.addEventListener('click',function(e){
      if(!sPanel)return; e.preventDefault();
      var willOpen=sPanel.hasAttribute('hidden');
      if(willOpen){sPanel.removeAttribute('hidden');var i=sPanel.querySelector('input');if(i)i.focus()}else{sPanel.setAttribute('hidden','')}
      d.querySelectorAll('[data-ug-search-toggle]').forEach(function(x){x.setAttribute('aria-expanded',willOpen?'true':'false')});
    });
  });
  d.addEventListener('keydown',function(e){if(e.key==='Escape'&&sPanel&&!sPanel.hasAttribute('hidden')){sPanel.setAttribute('hidden','')}});

  /* mobile drawer with focus handling */
  var drawer=d.querySelector('[data-ug-drawer]'), lastFocus=null;
  function focusables(){return drawer.querySelectorAll('a[href],button,summary,input')}
  function openDrawer(){
    lastFocus=d.activeElement; drawer.classList.add('is-open'); drawer.removeAttribute('aria-hidden'); drawer.removeAttribute('inert'); body.classList.add('ug-lock');
    d.querySelectorAll('[data-ug-drawer-open]').forEach(function(b){b.setAttribute('aria-expanded','true')});
    var f=focusables(); if(f.length)f[0].focus();
  }
  function closeDrawer(){
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); drawer.setAttribute('inert',''); body.classList.remove('ug-lock');
    d.querySelectorAll('[data-ug-drawer-open]').forEach(function(b){b.setAttribute('aria-expanded','false')});
    if(lastFocus)lastFocus.focus();
  }
  if(drawer){
    d.querySelectorAll('[data-ug-drawer-open]').forEach(function(b){b.addEventListener('click',openDrawer)});
    drawer.querySelectorAll('[data-ug-drawer-close]').forEach(function(b){b.addEventListener('click',closeDrawer)});
    drawer.addEventListener('keydown',function(e){
      if(e.key==='Escape'){closeDrawer();return}
      if(e.key!=='Tab')return;
      var f=Array.prototype.filter.call(focusables(),function(el){return el.offsetParent!==null});
      if(!f.length)return;
      var first=f[0], last=f[f.length-1];
      if(e.shiftKey&&d.activeElement===first){e.preventDefault();last.focus()}
      else if(!e.shiftKey&&d.activeElement===last){e.preventDefault();first.focus()}
    });
    window.addEventListener('resize',function(){if(window.innerWidth>=990&&drawer.classList.contains('is-open'))closeDrawer()});
  }

  /* footer accordions: open on desktop, collapsible on mobile */
  var mq=window.matchMedia('(min-width: 990px)');
  function syncFooter(){d.querySelectorAll('[data-ug-footer-acc]').forEach(function(el){if(mq.matches)el.setAttribute('open','')})}
  syncFooter(); if(mq.addEventListener)mq.addEventListener('change',syncFooter);
  /* ---------- Product form: variants, gallery, ajax add to cart ---------- */
  d.querySelectorAll('[data-ug-product]').forEach(function(root){
    var jsonEl=root.querySelector('[data-ug-product-json]'); if(!jsonEl)return;
    var product; try{product=JSON.parse(jsonEl.textContent)}catch(e){return}
    var form=root.querySelector('[data-ug-form]'), idInput=root.querySelector('[data-ug-variant-id]');
    var mainImg=root.querySelector('.ug-pdp__main img');
    var money=function(c){var v=(c/100).toFixed(2);return '$'+v.replace(/\B(?=(\d{3})+(?!\d))/g,',')};
    function selected(){return Array.prototype.map.call(root.querySelectorAll('[data-ug-option]'),function(fs){var c=fs.querySelector('input:checked');return c?c.value:null})}
    function findVariant(opts){return product.variants.find(function(v){return v.options.every(function(o,i){return o===opts[i]})})}
    function showImage(src,srcset,id){
      if(!mainImg||!src)return; mainImg.src=src; if(srcset)mainImg.srcset=srcset;
      root.querySelectorAll('[data-ug-thumb]').forEach(function(t){var on=String(t.getAttribute('data-ug-thumb'))===String(id);t.classList.toggle('is-active',on);if(on)t.setAttribute('aria-current','true');else t.removeAttribute('aria-current')});
    }
    function markAvailability(opts){
      root.querySelectorAll('[data-ug-option]').forEach(function(fs,idx){
        fs.querySelectorAll('input').forEach(function(inp){
          var test=opts.slice(); test[idx]=inp.value;
          var ok=product.variants.some(function(v){return v.available&&v.options.every(function(o,i){return o===test[i]})});
          inp.closest('.ug-opt__pill').classList.toggle('is-unavailable',!ok);
        });
      });
    }
    function update(){
      var opts=selected(); var v=findVariant(opts);
      root.querySelectorAll('[data-ug-option]').forEach(function(fs,i){var l=fs.querySelector('[data-ug-opt-label]');if(l)l.textContent=opts[i]||''});
      markAvailability(opts);
      var add=root.querySelector('[data-ug-add]'), addTxt=root.querySelector('[data-ug-add-text]'), stock=root.querySelector('[data-ug-stock]');
      if(!v){add.disabled=true;addTxt.textContent='Unavailable';if(stock)stock.textContent='This combination is unavailable';return}
      idInput.value=v.id;
      add.disabled=!v.available; addTxt.textContent=v.available?'Add to cart':'Sold out';
      if(stock)stock.textContent=v.available?'In stock':'Sold out';
      var pc=root.querySelector('[data-ug-price-current]'), cmp=root.querySelector('[data-ug-price-compare]');
      if(pc)pc.textContent=money(v.price);
      if(cmp){if(v.compare_at_price&&v.compare_at_price>v.price){cmp.hidden=false;cmp.lastChild.textContent=money(v.compare_at_price)}else cmp.hidden=true}
      var sku=root.querySelector('[data-ug-sku]'); if(sku)sku.textContent=v.sku||'';
      if(v.featured_media){var t=root.querySelector('[data-ug-thumb="'+v.featured_media.id+'"]');if(t)showImage(t.getAttribute('data-src'),t.getAttribute('data-srcset'),v.featured_media.id)}
      if(history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u.toString())}
    }
    root.querySelectorAll('[data-ug-option] input').forEach(function(i){i.addEventListener('change',update)});
    root.querySelectorAll('[data-ug-thumb]').forEach(function(t){t.addEventListener('click',function(){showImage(t.getAttribute('data-src'),t.getAttribute('data-srcset'),t.getAttribute('data-ug-thumb'))})});
    root.querySelectorAll('[data-ug-qty]').forEach(function(b){b.addEventListener('click',function(){var q=root.querySelector('input[name=quantity]');q.value=Math.max(1,(parseInt(q.value,10)||1)+parseInt(b.getAttribute('data-ug-qty'),10))})});
    markAvailability(selected());
    if(form){form.addEventListener('submit',function(e){
      if(!window.fetch)return; e.preventDefault();
      var btn=root.querySelector('[data-ug-add]'), err=root.querySelector('[data-ug-error]');
      btn.classList.add('is-loading'); btn.disabled=true; if(err)err.hidden=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
        .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
        .then(function(){
          if(window.theme&&theme.miniCart){theme.miniCart.updateElements();theme.miniCart.generateCart()}
          else{d.querySelectorAll('.js-cart-count').forEach(function(c){c.textContent=String((parseInt(c.textContent,10)||0)+1)})}
          var mc=d.querySelector('.js-mini-cart'); if(mc&&mc.getAttribute('data-cartmini')==='true'){mc.classList.add('active')}else{location.href='/cart'}
        })
        .catch(function(j){if(err){err.textContent=(j&&(j.description||j.message))||'Could not add to cart. Please try again.';err.hidden=false}})
        .finally(function(){btn.classList.remove('is-loading');var v=findVariant(selected());btn.disabled=!(v&&v.available)});
    })}
  });
})();
